import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Heredia.svg";
import { CAMPAIGN_2020 } from '../../../../constants';

const stateName = "Heredia";
const stateId = "jFFOuEtDTDEhewnxjM7l";

const Heredia = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2020" campaign={CAMPAIGN_2020}>
      <StateIcon />
    </State>
  );
};

export default Heredia;
